//natives
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

//components
import Table from "../../../../../../../util/Table/.mixins/Table";
import Error from "../../../../../../../util/error/.mixins/Error";
import Filter from "../../../../../../../util/filter/.mixins/Filter";
import ListaVazia from "../../../../../../../util/listaVazia/.mixins/ListaVazia";
//css
import PedidosListaCss from './PedidosLista-css';
const useStyles = PedidosListaCss();

export default function PedidosLista(props) {
    const classes = useStyles();
    return (
        <div className="container">
            <Filter {...props}/>
            <br/>
            {props.state.isLoading &&
            <div align="center">
                <CircularProgress />
            </div>
            }
            {!props.state.isLoading && !props.state.isError && 
              props.state.listaDescontos.length != [] &&
                <Table {...props} className={classes.root}/>
            }
            {!props.state.isLoading && !props.state.isError &&
              props.state.listaDescontos.length == [] &&
                <div>
                    <ListaVazia
                        tipoMensagem={"Alert"}
                        text={"Você não tem condições de pagamento liberadas"}
                        textDescription={"Se necessário entrar em contato com equipe Tok&Stok"}
                    />
                </div>
            }
            {props.state.isError &&
            <div align="center">
                <Error text={props.state.error}/>
            </div>
            }
        </div>
    );

}
